import React, { useState, useCallback } from 'react';
import { Image } from '@fiverr-private/media';
import { useAvatarContext } from '../AvatarContext';
import { AvatarImageProps } from './types';
import classes from './index.module.scss';

const AvatarImage = ({
    src,
    lazyLoad = true
}: AvatarImageProps) => {
    const { nameValue } = useAvatarContext();

    const [isImageBroken, setIsImageBroken] = useState(false);

    const onImageError = useCallback(() => {
        setIsImageBroken(true);
    }, []);

    const showImage = src && !isImageBroken;

    return (
        showImage ?
            <Image role={'img'}
                className={classes.avatarImage}
                src={src}
                alt={nameValue}
                loading={lazyLoad ? 'lazy' : 'eager'}
                onError={onImageError}/>
            :
            null

    );
};

AvatarImage.id = 'AvatarImage';
AvatarImage.dispalyName = 'AvatarImage';

export default AvatarImage;
